/**
 * The failure classification returned by the External API on payment operations.
 * Identical semantics for both clearing providers - the landing page never knows which
 * provider a company uses.
 *
 * Only PaymentMethodUnusable is destructive. Everything else, including Unknown, keeps the stored card.
 */
const paymentFailureReasonEnum = {
  Unknown: "Unknown",
  PaymentMethodUnusable: "PaymentMethodUnusable",
  Declined: "Declined",
  Transient: "Transient",
  Configuration: "Configuration",
};

export default paymentFailureReasonEnum;
